export const getters = {
    hasTestApiKeys: state => {
        return Boolean(state.testPublicKey && state.testSecretKey);
    },
};